import Divider from '@mui/material/Divider';
import React from 'react';
import { passSx, sxPropType } from '../../utils';
const AppbarDivider = ({ sx, ...props })=>/*#__PURE__*/ React.createElement(Divider, {
        sx: [
            {
                my: 2,
                mx: 2,
                borderColor: 'white.shades.12p'
            },
            ...passSx(sx)
        ],
        orientation: "vertical",
        variant: "middle",
        flexItem: true,
        ...props
    });
AppbarDivider.propTypes = {
    sx: sxPropType
};
export default AppbarDivider;
